import SudokuCell from './SudokuCell';

const cellKey = (row, col) => `${row}:${col}`;

export default function SudokuGrid({
  grid,
  givenMask,
  onCellSelect,
  errorCells = [],
  hintCells = [],
  selectedCell = null,
  selectedValue = null,
  notes = {},
}) {
  const errorSet = new Set(errorCells.map(({ row, col }) => cellKey(row, col)));
  const hintSet = new Set(hintCells.map(({ row, col }) => cellKey(row, col)));

  return (
    <div className="inline-grid min-w-fit grid-cols-9 gap-0.5 rounded-[1.25rem] bg-slate-900 p-1.5 shadow-2xl shadow-slate-300/60 sm:rounded-[1.5rem] sm:p-2">
      {grid.flat().map((cellValue, idx) => {
        const row = Math.floor(idx / 9);
        const col = idx % 9;

        const borderClasses = `
          ${col % 3 === 0 ? 'border-l-4' : 'border-l'}
          ${row % 3 === 0 ? 'border-t-4' : 'border-t'}
          ${col === 8 ? 'border-r-4' : ''}
          ${row === 8 ? 'border-b-4' : ''}
          border-black
        `;

        return (
          <SudokuCell
            key={idx}
            value={cellValue}
            readOnly={Boolean(givenMask[row][col])}
            borderClasses={borderClasses}
            hasError={errorSet.has(cellKey(row, col))}
            isHintTarget={hintSet.has(cellKey(row, col))}
            isSelected={selectedCell?.row === row && selectedCell?.col === col}
            isPeerCell={
              Boolean(selectedCell) &&
              (selectedCell.row === row ||
                selectedCell.col === col ||
                (
                  Math.floor(selectedCell.row / 3) === Math.floor(row / 3) &&
                  Math.floor(selectedCell.col / 3) === Math.floor(col / 3)
                ))
            }
            hasMatchingValue={
              selectedValue !== null &&
              cellValue !== null &&
              selectedValue === cellValue
            }
            noteValues={notes[cellKey(row, col)] || []}
            onSelect={() => onCellSelect(row, col)}
          />
        );
      })}
    </div>
  );
}
